import jwt from 'jsonwebtoken';

export const jwtDecode = (token)=>{
    return jwt.decode(token);
}
export const jwtEncode = (data) =>{
    // kDitS1Y7Sv88zS4oMeEZZyVTPuESfDj3
    const key = 'JustSampleJWTKey';
    return jwt.sign(data, key);
}